// extracted by mini-css-extract-plugin
module.exports = {"msgWrap":"Notify_msgWrap__2VOKq","msg":"Notify_msg__1rFrL","error":"Notify_error__3MskZ","warn":"Notify_warn__3soh3","info":"Notify_info__QoNme","close":"Notify_close__1lt-U"};